import { useEffect } from "react";

/**
 * Hides the Pyxa chatbot widget on the current page.
 * Pyxa injects iframes/launchers dynamically, so we poll briefly to catch them.
 * IMPORTANT: query descendants of <body> only, NEVER body itself, because
 * body has class="hide-chatbot" which would match `[class*="chatbot"]`.
 */
export default function useHideChatbot() {
  useEffect(() => {
    document.body.classList.add("hide-chatbot");

    // Selectors that target Pyxa's launcher/iframe but NOT our own hide-chatbot marker class.
    const selectors = [
      '[id*="pyxa" i]',
      '[class*="pyxa" i]',
      '[id*="chatbot" i]',
      // Match "chatbot" only when NOT preceded by "hide-" (avoids our own body marker
      // and any component named e.g. "no-chatbot-*").
      'iframe[src*="pyxa"]',
    ];

    const hide = () => {
      document.body.querySelectorAll(selectors.join(",")).forEach((el) => {
        if (el === document.body) return;
        el.style.display = "none";
      });
      // Handle class-based match with an explicit exclusion for our own marker.
      document.body
        .querySelectorAll('[class*="chatbot" i]')
        .forEach((el) => {
          if (el === document.body) return;
          if (el.classList.contains("hide-chatbot")) return;
          el.style.display = "none";
        });
    };

    hide();
    const interval = setInterval(hide, 500);
    const timeout = setTimeout(() => clearInterval(interval), 8000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      document.body.classList.remove("hide-chatbot");
      const restoreSelectors = [
        '[id*="pyxa" i]',
        '[class*="pyxa" i]',
        '[id*="chatbot" i]',
        '[class*="chatbot" i]',
        'iframe[src*="pyxa"]',
      ];
      document.body.querySelectorAll(restoreSelectors.join(",")).forEach((el) => {
        if (el === document.body) return;
        el.style.display = "";
      });
    };
  }, []);
}
